import React, { useEffect, useState } from 'react';
import { Table, Tag, Input, Space, Modal,Radio  } from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import "./TableView.css";
import { API_ERROR_MESSAGE, FIELD_HEADING, PLACEHOLDER } from '../shared/constants';
import { UserApiService } from '../services/api/UserAPIService';
import { formatDateTime } from '../shared/utils';
import { Box, TextField,Button,Snackbar, Alert } from '@mui/material';
import { DownloadOutlined } from '@ant-design/icons';


const { Search } = Input;

const TableView = ({data,onPageChange,currentPage, pageSize,onPageLoad}) => {
  const tableMetaData = data?.meta;
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState(data?.users);
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
const [selectedTimeFilter, setSelectedTimeFilter] = useState("all");
  const [snackData, setSnackData] = useState({
      show: false,
      message: "",
      type: "error",
    });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({ name:"",due_date:"",phone:"",status:"",activated_on:""});

  const handleEdit = (record) => {
    setEditingUser(record);
    setForm({ name:record?.name,due_date:record?.due_date,phone:record?.phone,status:record?.status,activated_on:record?.activated_on});
    setIsModalVisible(true);
  };

  const handleUpdate = () => {
    let payload ={...form};

    UserApiService.updateUser(form.phone,payload)
          .then((response) => {
            setFilteredData(response ? response : []);
            onPageLoad()
          })
          .catch((errResponse) => {
            setSnackData({
              show: true,
              message:
                errResponse?.response?.data?.message ||
                API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
              type: "error",
            });
          });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingUser(null);
  };

  // Function to filter data based on search input
  const handleSearch = (value) => {
    setSearchText(value);
    setDebouncedSearchText(value);
  };

  useEffect(()=>{
    setFilteredData(data?.users);
  },[data])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (debouncedSearchText?.trim()) {

        let payload={
            phone:debouncedSearchText,
            status:""
          }

        UserApiService.userByFilters(payload)
          .then((response) => {
            setFilteredData(response ? response : []);
          })
          .catch((errResponse) => {
            setSnackData({
              show: true,
              message:
                errResponse?.response?.data?.message ||
                API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
              type: "error",
            });
          });
      } else {
        setFilteredData(data?.users); // reset if input is empty
      }
    }, 300); // debounce delay in ms

    return () => {
      clearTimeout(handler); // clean up timeout on value change
    };
  }, [debouncedSearchText, data?.users]);


  const calculateGestationalDays = (dueDateStr) => {
    const dueDate = dayjs(dueDateStr);
    if (!dueDate.isValid()) return 0;

    const today = dayjs();
    return 280 - dueDate.diff(today, 'day');
  };

  const columns = [
    {
      title: 'S.No.',
      dataIndex: 'sno',
      key: 'sno',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      width: '5%',
    },
    {
      title: FIELD_HEADING.STATUS,
      // dataIndex: 'status',
      width:"10%",
      sorter: (a, b) => a?.status[0]?.localeCompare(b?.status[0]),
      render: (_, { status,payment_type }) => (
        <>
              <Tag
                color={status === 'Paid' || status === 'paid' || status ==='active' || status ==='Active' ? 'green' : status === 'Trial' || status === 'trial' || status ==='new' || status ==='New' ? 'yellow' : status === 'Unsubscribed' || status === 'unsubscribed' ? 'white' :  status === "registration incomplete" ? 'black' : status === "unpaid" || status === "unpaid" ? "black" : 'red'}
                key={status}
                style={{ backgroundColor: status === 'Paid' || status === 'paid' || status ==='active' || status ==='Active' ? 'green' : status === 'Trial' || status === 'trial' || status ==='new' || status ==='New' ? 'yellow' : status === 'Unsubscribed' || status === 'unsubscribed' ? '#1c1c1c' : status === "registration incomplete" ? "#a1a1a1" : status === "unpaid" || status === "unpaid" ? "#ffcb32" :'red', color: status === 'Trial' || status === 'trial' || status ==='new' || status ==='New' || status === "registration incomplete" || status === "unpaid" || status === "Unpaid" ? "black" : 'white' }}
              >
                {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
              </Tag>
              {status === "paid" && payment_type &&
              <span style={{fontWeight:"600"}}>({payment_type})</span>
              }
        </>
      ),
    },
    {
      title: FIELD_HEADING.LAST_RECEIPT,
      dataIndex: 'receiptTime',
      width:"20%",
      render:(_,{receiptTime}) => formatDateTime(receiptTime),
      sorter: (a, b) =>
        dayjs(a?.receiptTime, 'MMM D YYYY hh:mm A') - dayjs(b?.receiptTime, 'MMM D YYYY hh:mm A'),
    },
    {
      title: FIELD_HEADING.NAME,
      dataIndex: 'name',
     //   sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: FIELD_HEADING.PHONE,
      dataIndex: 'phone',
     //   sorter: (a, b) => a.phone.localeCompare(b.phone),
    },
    {
      title: FIELD_HEADING.DUE_DATE,
      dataIndex: 'due_date',
     //   sorter: (a, b) => a.phone.localeCompare(b.phone),
    },
    {
      title: FIELD_HEADING.GESTATIONAL_AGE,
      dataIndex: 'due_date',
      render: (dueDate) => extractGestationalAge(dueDate),
      sorter: (a, b) => {
        const ageA = calculateGestationalDays(a?.due_date);
        const ageB = calculateGestationalDays(b?.due_date);
        return ageA - ageB;
      },
    },
    {
      title: FIELD_HEADING.SMS_SENT,
      dataIndex: 'chat_count',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (_, record) => (
        <Button type="link" onClick={(e) => {
          e.stopPropagation();
          handleEdit(record);
        }}>
          Edit
        </Button>
      ),
    }
  ];

  const handleDownloadAllUsers = async (filter) => {
    if (!filteredData || filteredData.length === 0) {
      setSnackData({
        show: true,
        message: "No users to download messages for.",
        type: "error",
      });
      return;
    }

    setSnackData({
      show: true,
      message: "Started downloading Messages for all users.",
      type: "success",
    });

    let allConversations = "";

    for (const user of filteredData) {
      const phone = user.phone;
      if (!phone) continue;

      try {
        const response = await UserApiService.userConversation(phone, 1, 999, filter);
        const fetchedMessages = response.messages || [];

        if (fetchedMessages.length === 0) continue;

        const userHeader = `\n\n📞 Conversation with: ${phone}\n📅 Total Messages: ${fetchedMessages.length}\n-----------------------------\n`;

        const userMessages = fetchedMessages
          .map(
            (msg) =>
              `${new Date(msg.received_at).toUTCString()} - [${msg.source.toUpperCase()}]: ${msg.body}`
          )
          .join("\n\n");

        allConversations += userHeader + userMessages + `\n\n🔚 End of ${phone} conversation\n\n=========================================================\n`;
      } catch (error) {
        console.error(`Failed for ${phone}:`, error);
      }
    }

    if (allConversations.trim().length === 0) {
      setSnackData({
        show: true,
        message: "No conversations found for selected users.",
        type: "info",
      });
      return;
    }

    // Create and download a single text file
    const blob = new Blob([allConversations], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `All_User_Conversations.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    setSnackData({
      show: true,
      message: "Messages downloaded for all users.",
      type: "success",
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <Space style={{display:"grid",marginBottom:"-50px",position: 'relative',zIndex: 10000000,float: "right" }}>
      <Button  variant="contained"
                color="primary" startIcon={<DownloadOutlined />} onClick={() => setIsDownloadModalOpen(true)} style={{ padding: '8px 16px',marginBottom:"20px" }}>
      Download ALL User Conversation History
  </Button>
        <Search
          placeholder={PLACEHOLDER.SEARCH}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 300,float:"right" }}
          allowClear
        />
      </Space>
      <Table
  className="custom-table"
  columns={columns}
  dataSource={filteredData}
  pagination={{
    current: currentPage,
    pageSize: pageSize,
    total: tableMetaData?.total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    onChange: (page, size) => {
      if (typeof onPageChange === "function") {
        onPageChange(page, size);
      }
    },
    position: ["topLeft", "bottomRight"],
    showTotal: (total, range) =>
      `Showing ${range[0]}-${range[1]} of ${total} records`,
  }}
  onRow={(record) => ({
    onClick: () => {
      navigate(`/admin/user/${record?.phone}`, { state: { data: record } });
    },
  })}
  rowClassName="clickable-row"
/>

<Modal
  title="Edit User"
  visible={isModalVisible}
  onOk={handleUpdate}
  onCancel={handleCancel}
  okText="Update"
  cancelText="Cancel"
>
      <Box display="flex" flexDirection="column" gap={2} p={2}>
        <TextField
          label="name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          type="text"
          fullWidth
        />
        <TextField
          label="phone"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          type="text"
          disabled
          fullWidth
        />

         <TextField
          label="status"
          value={form.status}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
          type="text"
          fullWidth
        />

        <TextField
          label="due_date"
          value={form.due_date}
          onChange={(e) => setForm({ ...form, due_date: e.target.value })}
          type="text"
          fullWidth
        />
        <TextField
          label="Registration Date"
          value={form.activated_on}
          onChange={(e) => setForm({ ...form, activated_on: e.target.value })}
          type="text"
          fullWidth
        />
      </Box>



</Modal>

<Modal
  title="Download User Conversations"
  open={isDownloadModalOpen}
  onCancel={() => setIsDownloadModalOpen(false)}
  onOk={() => {
    handleDownloadAllUsers(selectedTimeFilter);
    setIsDownloadModalOpen(false);
  }}
  okText="Download"
  cancelText="Cancel"
>
  <p>Please select a time filter before downloading:</p>
  <Radio.Group
    value={selectedTimeFilter}
    onChange={(e) => setSelectedTimeFilter(e.target.value)}
    style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}
  >
    <Radio value="all">All</Radio>
    <Radio value="last_7_days">Last 7 Days</Radio>
    <Radio value="last_15_days">Last 15 Days</Radio>
    <Radio value="last_month">Last Month</Radio>
  </Radio.Group>
</Modal>


<Snackbar
        style={{ top: "80px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>

    </div>
  );
};

// Function to convert gestational age to a numerical value (in days)
const extractGestationalAge = (dueDateStr) => {
  if (!dueDateStr) return "";

  const dueDate = dayjs(dueDateStr); // will parse both 'YYYY-MM-DD' and 'MM/DD/YYYY'
  if (!dueDate.isValid()) return 0;

  const today = dayjs();
  const daysUntilDue = dueDate.diff(today, 'day'); // future: positive, past: negative
  const gestationDays = 279 - daysUntilDue;

  if (gestationDays < 0) return "Not Pregnant Yet";
  if (gestationDays > 280) return "Post Due";

  const weeks = Math.floor(gestationDays / 7);
  const days = gestationDays % 7;

  return `${weeks} week${weeks !== 1 ? 's' : ''} ${days} day${days !== 1 ? 's' : ''}`;
};


export default TableView;
